<script setup>
const props = defineProps({
  color: {type: String, default: '#9CA3AF'},
});
</script>

<template>
  <svg width="44" height="44" :viewBox="`0 0 44 44`" :fill="color" stroke="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_31_279548)">
      <path
        d="M2.21053 42H30.9474C31.5336 42 32.0959 41.7671 32.5104 41.3526C32.925 40.938 33.1579 40.3757 33.1579 39.7895V19.8947C33.1579 19.3085 32.925 18.7462 32.5104 18.3317C32.0959 17.9171 31.5336 17.6842 30.9474 17.6842H0V39.7895C0 40.3757 0.232894 40.938 0.647448 41.3526C1.062 41.7671 1.62426 42 2.21053 42Z"
      />
      <path
        d="M0 13.2632H16.4529L13.8003 9.72632C13.5944 9.45178 13.3274 9.22895 13.0205 9.07548C12.7135 8.922 12.3751 8.8421 12.0319 8.8421H2.21053C1.62426 8.8421 1.062 9.075 0.647448 9.48955C0.232894 9.90411 0 10.4664 0 11.0526V13.2632Z"
      />
      <path
        d="M37.5789 8.8421H27.5056L22.2003 1.76842C21.7874 1.22048 21.2532 0.775655 20.6396 0.468832C20.0259 0.162009 19.3495 0.0015359 18.6635 0H8.8421C7.66957 0 6.54506 0.465788 5.71595 1.2949C4.88684 2.124 4.42105 3.24852 4.42105 4.42105H12.0319C13.061 4.42344 14.0755 4.66419 14.996 5.12442C15.9165 5.58464 16.7178 6.25184 17.3372 7.07368L21.9793 13.2632H30.9474C32.7062 13.2632 34.3929 13.9618 35.6366 15.2055C36.8803 16.4492 37.5789 18.1359 37.5789 19.8947V37.5789C38.7515 37.5789 39.876 37.1132 40.7051 36.284C41.5342 35.4549 42 34.3304 42 33.1579V13.2632C42 12.0906 41.5342 10.9661 40.7051 10.137C39.876 9.30789 38.7515 8.8421 37.5789 8.8421Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_31_279548">
        <rect width="44" height="44" :fill="color"/>
      </clipPath>
    </defs>
  </svg>
</template>
